import React, { ReactNode, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Header from "./Header";
import { PiCirclesFourFill } from "react-icons/pi";
import { FaAngleLeft, FaAward, FaBell } from "react-icons/fa6";
import { CiMenuFries } from "react-icons/ci";
import { HiUsers } from "react-icons/hi2";
import { GiWeightLiftingUp } from "react-icons/gi";
import { MdCastForEducation, MdOutlineDiscount, MdSportsGymnastics } from "react-icons/md";
import { GiMountainClimbing } from "react-icons/gi";
interface SidebarProps {
  children: ReactNode;
}

const Sidebar: React.FC<SidebarProps> = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const ActiveClass = () => {
    return " bg-white text-darkCyan font-semibold ";
  };
  const UnActiveClass = () => {
    return " bg-darkCyan text-white font-normal  font-medium ";
  };
  const links = [
    { to: "/users", icon: <HiUsers size={20} />, label: "Users" },
    {
      to: "/exercises",
      icon: <GiWeightLiftingUp size={20} />,
      label: "Exercises",
    },
    {
      to: "/workouts",
      icon: <MdSportsGymnastics size={20} />,
      label: "Workout",
    },
    {
      to: "/challenges",
      icon: <GiMountainClimbing size={20} />,
      label: "Challenges",
    },
    { to: "/notification", icon: <FaBell size={20} />, label: "Notification" },
    {
      to: "/courses",
      icon: <MdCastForEducation size={20} />,
      label: "Courses",
    },
    {
      to: "/reward",
      icon: <FaAward size={20} />,
      label: "Rewards",
    },
    {
      to: "/badges",
      icon: <MdOutlineDiscount size={20} />,
      label: "Badges",
    },
  ];
  const SidebarLinks = () => {
    return (
      <nav className="lg:w-72   lg:h-screen bg-darkCyan overflow-y-auto  p-4">
        <div className="p-2 bg-white rounded-2xl">
          <Link to={"/"}>
            <img src="/images/logo.png" className="w-full" alt="" />
          </Link>
        </div>
        <ul className=" flex flex-col mt-5">
          <NavLink
            to={"/"}
            className={({ isActive }: { isActive: boolean }) =>
              ` text-black flex gap-2 items-center p-3 text-lg rounded-lg my-2  ${
                isActive ? ActiveClass() : UnActiveClass()
              }`
            }
          >
            <PiCirclesFourFill size={20} />
            Dashboard
          </NavLink>

          {links.map(({ to, icon, label }) => (
            <Link
              key={to}
              to={to}
              className={`text-black flex gap-2 items-center text-lg p-3 rounded-lg my-2 ${
                pathname.startsWith(to) ? ActiveClass() : UnActiveClass()
              }`}
            >
              {icon}
              {label}
            </Link>
          ))}
        </ul>
      </nav>
    );
  };
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
  return (
    <div className="lg:flex lg:bg-darkCyan lg:h-screen">
      {/* Sidebar */}
      <div className="hidden lg:block sidebar">{SidebarLinks()}</div>
      <div className="lg:hidden block sidebar ">
        <div className="flex justify-between items-center bg-darkCyan p-2 border-b ">
          <div className="p-2 bg-white rounded-2xl">
            <img src="/images/logo.png" width={150} alt="" />
          </div>{" "}
          <button
            onClick={toggleSidebar}
            className=" focus:outline-none text-darkCyan bg-white p-2 rounded-xl"
          >
            <CiMenuFries size={30} />
          </button>
        </div>

        {isSidebarOpen && (
          <div
            className={`fixed top-0 left-0  w-full  z-10 bg-[#00000087] transition-transform transform ${
              isSidebarOpen ? "translate-x-0" : "-translate-x-full"
            }`}
          >
            <div className="w-1/2 bg-darkCyan relative ">
              <button
                onClick={toggleSidebar}
                className=" w-8 h-8 flex justify-center items-center focus:outline-none absolute top-8 -right-5 bg-darkCyan border-2 text-white border-white rounded-full"
              >
                <FaAngleLeft />
              </button>
              <div className="w-full h-screen overflow-y-auto">
                {SidebarLinks()}
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col  lg:h-screen overflow-y-auto p-4 bg-gray-100 rounded-s-3xl overflow-x-hidden	 ">
        <Header />
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
